export default __webpack_public_path__ + "static/media/frankie.e964fd80.jpeg";